module.exports = __webpack_public_path__ + "static/media/shuri-atomi-lose.e1303df8.jpg";